import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";

const { default: sheet } = CSS_MODULE_SCRIPTS
	? await import("./button.module.css", { with: { type: "css" } })
	: await importCss("./button.module.css", import.meta.url);
export default adopt(sheet);
